var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex min-h-screen flex-col bg-slate-800 text-white"},[_c(_setup.SiteHeader),_c('div',{staticClass:"flex-1"},[_c(_setup.RouterView)],1),_c(_setup.SiteFooter)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }